<template>
    <form id="SkillForm" class="needs-validation" novalidate>
        <div class="row g-3">
            <!-- Skill Field -->
            <div class="col-md-4">
                <label for="skillId"><strong>{{ $Translate('skill') }}: </strong><span
                        class="text-danger">*</span></label>
                <select class="form-control"
                    :class="{ 'is-valid': skillSubmitted && skillIdIsValid, 'is-invalid': skillSubmitted && !skillIdIsValid }"
                    id="skillId" v-model="skill.skillId" @change="$emit('skill-changed', skill.skillId)" required>
                    <option value="" selected disabled>{{ $Translate('selectSkillId') }}</option>
                    <option v-for="sk in skillsList.filter(s => s.description !== '')" :key="sk.recId"
                        :value="sk.skillId">
                        {{ sk.description }}
                    </option>
                </select>
            </div>

            <!-- Rating Level Field -->
            <div class="col-md-4" v-if="(this.skill.skillId != '')">
                <label for="ratingLevelId"><strong>{{ $Translate('ratingLevel') }}: </strong><span
                        class="text-danger">*</span></label>
                <select class="form-control"
                    :class="{ 'is-valid': skillSubmitted && ratingLevelIdIsValid, 'is-invalid': skillSubmitted && !ratingLevelIdIsValid }"
                    id="ratingLevelId" v-model="skill.ratingLevelId" required>
                    <option value="" selected disabled>{{ $Translate('selectRatingLevel') }}</option>
                    <option v-for="rt in ratingLevelList" :key="rt.recId" :value="rt.recId">
                        {{ rt.description }}
                    </option>
                </select>
            </div>
        </div>
    </form>
</template>

<script>
export default {
    name: 'Skills',
    props: {
        skill: Object,
        skillSubmitted: Boolean,
        skillList: Array,
        skillsList: Array,
        ratingLevelList: Array,
        skillIdIsValid: Boolean,
        ratingLevelIdIsValid: Boolean
    }
}
</script>

<style scoped>
.col-md-4 {
    text-align: start;
}

.col-md-4 label {
    margin-bottom: 10px;
}

.col-md-4 input,
.col-md-4 select,
.col-md-4 textarea {
    margin-bottom: 12px;
}

.col-md-4 select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: url('../../../../dist/assets/select.svg') no-repeat right 0.75rem center;
    background-color: #fff;
    background-size: 16px 16px;
    padding-right: 2rem;
    line-height: 1.5;
    height: calc(1.5em + 0.75rem + 2px);
}
</style>